import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {
  "agent-permission": () => import("/app/middleware/agent-permission.ts"),
  "owner-permission": () => import("/app/middleware/owner-permission.ts"),
  auth: () => import("/app/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/auth.mjs")
}